import { endpoints } from "config/endpoints.config"
import { InputType } from "lib/constants"
import { GenericResource, IGenericModel, generic } from "models/generic"

export type IAppField = {
  id: string
  label: string
  name: string
  action?: string
  description?: string
  required: boolean
  type: InputType
  inline?: boolean
  disabled?: boolean
  defaultValue?: any
  options?: {
    value: string
    label: string
  }[]
}

interface AppPlugin {
  enabled: boolean
  mode: string
  height: number
  width: number
  title: string
  description: string
  icon: string
}

export interface IApp extends GenericResource {
  name: string
  description: string
  shortDescription: string
  avatar: string
  color: string
  isActive?: boolean
  type: string
  fields?: IAppField[]
  botFields?: IAppField[]
  plugins: Record<"inbox" | "header", AppPlugin>
  workspaces: string[]
}

export const apps: IGenericModel<IApp> = {
  ...generic(endpoints.APPS),
}
